import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { MonthYearItem } from '../../model/period';
import { SelectionItem } from '../select/select.component';
import { InputControlBase } from '../forms/input-control.base';

@Component({
    selector: 'app-month-year-select',
    templateUrl: './month-year-select.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class MonthYearSelectComponent extends InputControlBase {
  private _itemsSource: MonthYearItem[] = [];

  constructor(private readonly translate: TranslateService) {
    super();
  }

  @Input()
  set itemsSource(itemsSource: MonthYearItem[] | null | undefined) {
    this._itemsSource = itemsSource ?? [];
    this.selectionItems = this._itemsSource.map(item => ({
      name: `${item.year} ${this.translate.instant(item.monthName)}`,
      value: item,
    }));
  }

  get itemsSource(): MonthYearItem[] {
    return this._itemsSource;
  }

  selectionItems: SelectionItem<MonthYearItem>[] = [];

  ngOnInit() {}
}
